<template>
  <div>
    <div class="font_bold text_center" >{{realData.title}}</div>
    <div class="chart" :ref="realRef" style="height:400px"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    unitIndex: [Number, String],
    unitInfo: [Array]
  },
  data() {
    return {
      option: {},
      chartData: {
        1: { color: "#A6D1F9", title: this.$t("dashboard.Maturity.days") },
        2: { color: "#FE766C", title: this.$t('seller.sell.SellModal.LPDs') },
        3: { color: "#F6DA8F", title: this.$t("dashboard.Duration") }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setData();
    });
  },
  methods: {
    setData() {
      let option = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            data: []
          }
        ]
      };
      let unitInfo = this.unitInfo;
      let xAxisData = [];
      let seriesData = [];
      // lowerLimit <3
      // lowerType  <=3
      //  "lowerLimit": 3,
      // "lowerType": "INCLUSIVE",  包括
      // "upperLimit": 4,
      // "upperType": "EXCLUSIVE" 不包括
      if (unitInfo && unitInfo.length > 0) {
        unitInfo.forEach(item => {
          let lowerText = "";
          let upperText = "";
          let { rangeInDays } = item;
          if (rangeInDays.lowerLimit) {
            lowerText =
             
              (rangeInDays.lowerType === "INCLUSIVE" ? "≥" : ">")+ rangeInDays.lowerLimit ;
          }
          if (rangeInDays.upperLimit) {
            upperText =
            
              (rangeInDays.upperType === "INCLUSIVE" ? "≤" : "<")+  rangeInDays.upperLimit ;
          }
          if (rangeInDays.lowerLimit && rangeInDays.upperLimit) {
            xAxisData.push(
              rangeInDays.lowerLimit + "-" + rangeInDays.upperLimit
            );
          }else{
          xAxisData.push(lowerText + upperText);
          }
          seriesData.push(item.soldCount);
        });
      }

      option.xAxis[0].data = xAxisData;
      option.series[0].data = seriesData;
      option.color = [this.realData.color];
      let myChart = echarts.init(this.$refs[this.realRef]);
      myChart.setOption(option);
      setTimeout(function() {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 500);
    },
    setOption() {}
  },
  computed: {
    realRef() {
      return "chartUnit" + this.unitIndex;
    },
    realtile() {
      return this.chartData[this.unitIndex].title;
    },
    realData() {
      return this.chartData[this.unitIndex];
    },
    ...mapGetters({ dashboardInfo: "dashboardInfo" })
  },
  watch: {
    dashboardInfo() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.setData();
        });
      }, 500);
    }
  }
};
</script>